import "./home.css"






function Home() {

     let url = "localhost:8080"
     var value ="toggle"
     const szene1 = async () => {

     
         

          const response = await fetch("http://" + url + "/controller/szene1/", {
             method: "POST",
             headers: {
                 "Content-Type": "application/json"
             },

             body: JSON.stringify({
                 value
              }) 
         })
         const status = await response.json()
         
         console.log(status._status)
     
}

const szene2 = async () => {

     
         

     const response = await fetch("http://" + url + "/controller/szene2/", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },

        body: JSON.stringify({
            value
         }) 
    })
    const status = await response.json()
    
    console.log(status._status)

}
const szene3 = async () => {

     
         

     const response = await fetch("http://" + url + "/controller/szene3/", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },

        body: JSON.stringify({
            value
         }) 
    })
    const status = await response.json()
    
    console.log(status._status)

}


     return (
          <div className="Home">
               <div className="intro">
                    <h1 className="welcome"> Brighten your Day </h1>
               </div>
               <div>
               <button className="button btnn" onClick={() => szene1()}>
                            Fernsehen
               </button>
               <button className="button btnn" onClick={() => szene2()}>
                            Hell
               </button>
               <button className="button btnn" onClick={() => szene3()}>
                            Essen
               </button>

               </div>
          </div>
     )
}

export default Home
